import angular from 'angular';
import moment from 'moment';

import '../../build/i18n-build';

config.$inject = ['$translateProvider'];

const DEFAULT_LOCALE = 'en';

function config($translateProvider) {
  $translateProvider
    .useSanitizeValueStrategy('escapeParameters')
    .preferredLanguage(DEFAULT_LOCALE)
    .useLocalStorage();

  moment.locale(DEFAULT_LOCALE);
}

export class I18nService {
  static $inject = ['$translate'];

  constructor(private $translate: angular.translate.ITranslateService) {}

  setLocale(locale: string) {
    this.$translate.use(locale);
    moment.locale(locale);
  }
}

export default angular
  .module('est.i18n', ['ngCookies', 'pascalprecht.translate', 'estoffice.i18n'])
  .service('i18nService', I18nService)
  .config(config);
